import {
  CollabFilterType,
  MutableCollabFilter,
} from '@databases/model/views/view-filter';

export function getTargetedFilter(
  filter: MutableCollabFilter,
  path: number[],
  append?: boolean
): [MutableCollabFilter, number] {
  let currentFilter = filter;
  let pathDepth = 0;

  for (pathDepth; pathDepth < (append ? path.length : path.length - 1); pathDepth++) {
    const filterIndex = path[pathDepth];

    if (
      filterIndex !== undefined &&
      (currentFilter.type === CollabFilterType.AND ||
        currentFilter.type === CollabFilterType.OR)
    ) {
      currentFilter = currentFilter.value[filterIndex];
    } else {
      break;
    }
  }

  return [currentFilter, pathDepth];
}
